var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.stockCatPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.stockCatPostErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.revenueSourceIndexGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.revenueSourceIndexGetErrors = $event
          }
        }
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    dense: "",
                    elevation: "0"
                  }
                },
                [
                  _c("span", [_vm._v("New Category")]),
                  _c("v-spacer"),
                  _c("v-icon", [_vm._v("mdi-shape")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Category ID",
                  disabled: _vm.editMode,
                  "error-messages": _vm.stockCatPostErrors.id || []
                },
                model: {
                  value: _vm.id,
                  callback: function($$v) {
                    _vm.id = $$v
                  },
                  expression: "id"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Revenue Source",
                  items: _vm.revenueSourceIndexList,
                  loading: _vm.revenueSourceIndexGetting,
                  "error-messages": _vm.stockCatPostErrors.revenue_source_id,
                  "item-value": "id",
                  "item-text": "code"
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.code))
                        ]),
                        _c("small", { staticClass: "ml-2 blue-grey--text" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.revenueSourceId,
                  callback: function($$v) {
                    _vm.revenueSourceId = $$v
                  },
                  expression: "revenueSourceId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Name",
                  "error-messages": _vm.stockCatPostErrors.name || []
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          !_vm.editMode
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        dark: "",
                        block: "",
                        loading: _vm.stockCatPosting
                      },
                      on: { click: _vm.storeStockCat }
                    },
                    [_c("span", [_vm._v("Save")])]
                  )
                ],
                1
              )
            : _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "yellow darken-2",
                                dark: "",
                                block: "",
                                loading: _vm.stockCategoryUpdatePutting
                              },
                              on: { click: _vm.update }
                            },
                            [_c("span", [_vm._v("Update")])]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "error", dark: "", block: "" },
                              on: { click: _vm.cancelEdit }
                            },
                            [_c("span", [_vm._v("Cancel")])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }